import type { LoanSetupData } from "@/components/LoanSetup";

/**
 * Merge a stored scenario `setup` blob over the current setup state.
 *
 * Pulse-launched scenarios persist only the keys the integration sends
 * (amount, rate, dates) — replacing the whole object with such a partial
 * leaves paymentFrequency / numberOfPayments undefined, which cascades into
 * periodicRate = NaN and NaN currency across the UI. Merging keeps sane
 * defaults for anything the blob does not carry; a full saved blob still
 * wins on every key it holds.
 */
export function mergeHydratedSetup(current: LoanSetupData, incoming: unknown): LoanSetupData {
  if (!incoming || typeof incoming !== "object" || Array.isArray(incoming)) {
    return current;
  }
  const patch: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(incoming as Record<string, unknown>)) {
    if (value !== undefined) patch[key] = value;
  }
  return { ...current, ...patch } as LoanSetupData;
}
